import { motion } from "framer-motion";
import { Globe, Film, SlidersHorizontal, TrendingUp, Users, Eye, UsersRound, Phone, BookUser } from "lucide-react";

const features = [
  {
    icon: Globe,
    title: "Rede Global Exclusiva",
    desc: "Os seus chips conversam com a nossa rede maturada de números reais em todo o mundo, gerando interações orgânicas diversificadas.",
    color: "text-warmz-green-bright",
  },
  {
    icon: Film,
    title: "Simulação Multimédia",
    desc: "O robô envia textos, áudios reais, imagens e stickers com probabilidades configuráveis para simular uso humano.",
    color: "text-primary",
  },
  {
    icon: Eye,
    title: "Stories Automáticos",
    desc: "Publica Status/Stories no WhatsApp automaticamente ao longo do dia — textos coloridos e imagens — simulando uma conta ativa e real.",
    color: "text-accent",
  },
  {
    icon: UsersRound,
    title: "Grupos de Aquecimento",
    desc: "Os seus números entram e interagem em grupos de aquecimento automaticamente. Cadastre os seus próprios grupos ou use os do sistema.",
    color: "text-primary",
  },
  {
    icon: TrendingUp,
    title: "Esteira de Fases Automática",
    desc: "Cada número evolui automaticamente de Cold → Warm → Hot → Mature, com perfis que se sucedem sem intervenção manual.",
    color: "text-warmz-green-bright",
  },
  {
    icon: SlidersHorizontal,
    title: "Perfis de Aquecimento",
    desc: "Perfis customizáveis com sliders de probabilidade para texto, áudio, sticker e imagem. Ajuste a intensidade de cada chip.",
    color: "text-warmz-orange-light",
  },
  {
    icon: BookUser,
    title: "Agenda de Contatos com Tags",
    desc: "Importe os seus contatos reais, organize por tags e envie mensagens automáticas para números que já conhecem o seu chip.",
    color: "text-accent",
  },
  {
    icon: Phone,
    title: "Contatos Oficiais Verificados",
    desc: "Receba e envie mensagens para contatos oficiais de grandes empresas, aumentando a credibilidade do seu número.",
    color: "text-warmz-green-bright",
  },
];

const Features = () => (
  <section id="funcionalidades" className="py-24 border-t border-warmz-glass-border/20">
    <div className="container mx-auto px-4 md:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground">
          Não é apenas enviar mensagens.{" "}
          <span className="gradient-text-fire">É simular um ser humano.</span>
        </h2>
        <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">
          Mensagens, stories, grupos, contatos reais — tudo o que uma conta ativa faz, o WarmZapp faz por si no automático.
        </p>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {features.map((f, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.06 }}
            className="glass-card p-6 hover:bg-warmz-card-hover/40 transition-all group"
          >
            <div className="w-11 h-11 rounded-xl bg-secondary flex items-center justify-center mb-4">
              <f.icon className={f.color} size={22} />
            </div>
            <h3 className="font-display text-base font-bold text-foreground mb-2">{f.title}</h3>
            <p className="text-muted-foreground text-sm leading-relaxed">{f.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Features;
